export default __webpack_public_path__ + "static/media/ic_ftm_30.d0b942ba.svg";